/**
 *
 * Header
 *
 */

import React, { Fragment } from "react"
import _header_es from "../../../translations/es/header.json"
import _header_en from "../../../translations/en/header.json"

import { Menu, Dropdown, Divider, Tooltip } from "antd"
import { Link, NavLink } from "react-router-dom"
import img from "images/brand/Mandu_white.svg"
import icon4 from "images/HeaderIcons/Rounded.svg"
import down from "images/down.svg"
import UserHeaderBox from "containers/UserHeaderBox"
import NotificationContainer from "containers/NotificationContainer"
import { QuestionCircleFilled } from "@ant-design/icons"
import {
  isAdmin,
  isAmbassador,
  isLeader,
  isModuleBySlug,
} from "../../../utils/storage"
import {
  CONTROL_PANEL,
  MEASURES,
  ORGANIZATION,
  REPORTS,
  SURVEYS,
  TRACING,
} from "../../../utils/constants"
import { buttonAction_btns } from "../../Snowplow/config2"
import chat from "images/chat.svg"
import helpCenterIcon from "images/help-center-icon.svg"

class Admin extends React.Component {
  intl = {}
  constructor() {
    super()
    this.intl = (localStorage.getItem("language") || "es") === "en" ? _header_en : _header_es
  }

  componentDidUpdate() {
  }

  dropdownQuestions = (
    <Menu style={{ padding: 0, width: 184, color: "#a1a1a1" }}>
      <Menu.Item className="damnMenuItem dropdown-option">
        <a
          href="https://intercom.help/center-mandu"
          onClick={() => buttonAction_btns("Ir a Help Center")}
          target="_blank"
          rel="noreferrer">
          Help Center
        </a>
      </Menu.Item>
      <Menu.Item
        className="damnMenuItem dropdown-option"
        id="dsadasdas"
        onClick={() => window.open("https://intercom-help.eu/mandu/es/collections/1400663-mandu-experience", "_blank")}>
        <Tooltip title="Help center" placement="bottom">
          <img src={helpCenterIcon} alt="Help Center" style={{ width: "21px", height: "21px", marginRight: 0 }} />
        </Tooltip>
      </Menu.Item>
    </Menu>
  )

  render() {
    const isAdministrator = isAdmin()
    const isReportModule = isModuleBySlug(REPORTS)
    const isOrganizationModule = isModuleBySlug(ORGANIZATION)
    const isSurveys = isModuleBySlug(SURVEYS)
    const isMeasures = isModuleBySlug(MEASURES)
    const isTracingModule = isModuleBySlug(TRACING)
    const isQuestionnaires = isSurveys && isMeasures
    const isControlPanel = isModuleBySlug(CONTROL_PANEL)

    const menuModels = (
      <Menu style={{ backgroundColor: "#2E52F8", padding: 0, width: 184 }}>
        {isSurveys && (
          <Menu.Item className="damnMenuItem">
            <Link to="/models/surveys">Cuestionarios</Link>
          </Menu.Item>
        )}
        {isMeasures && (
          <Menu.Item className="damnMenuItem">
            <Link to="/models/measure-history">Mediciones</Link>
          </Menu.Item>
        )}
      </Menu>
    )

    if(window.top !== window.self) {
      return null
    }

    return (
      <div className="container-header">
        <div className="container-header__left">
          <Fragment>
            <img width={80} src={img} className="container-header__logo" />
            <Divider type="vertical" />
            {isOrganizationModule && (
              <NavLink
                className="container-header__left-item step-menu-organization"
                activeClassName="container-header-active"
                to="/organization">
                Organización
              </NavLink>
            )}

            <Divider type="vertical" />
            {isQuestionnaires && (
              <NavLink activeClassName="" to="#">
                <Dropdown
                  className="container-header__left-item"
                  overlay={menuModels}>
                  <div
                    className={
                      window.location.href.indexOf("/models/") > -1
                        ? "container-header-active"
                        : ""
                    }>
                    Encuestas
                    <img src={down} style={{ margin: "2px 0 0 8px" }} />
                  </div>
                </Dropdown>
              </NavLink>
            )}

            <Divider type="vertical" />
            {isReportModule && (
              <NavLink
                className="container-header__left-item"
                activeClassName="container-header-active"
                to="/reports/dashboard">
                Reportes
              </NavLink>
            )}
            {isTracingModule && (
              <Fragment>
                <Divider type="vertical" />
                <NavLink
                  className="container-header__left-item"
                  activeClassName="container-header-active"
                  to="/action-plans">
                  Planes de acción
                </NavLink>
              </Fragment>
            )}
          </Fragment>
        </div>
        <div className="container-header__right">
          <Fragment>
          <Tooltip title="Help center" placement="bottom">
            <span className="container-header__left-item" style={{ fontWeight: "600", color: "white", cursor: "pointer" }}
              onClick={() => { 
                window.open("https://intercom-help.eu/mandu/es/collections/1400663-mandu-experience", "_blank")
              }}>
              <img src={helpCenterIcon} alt="Help Center" style={{ width: "21px", height: "21px", marginRight: 0 }} />
            </span>
          </Tooltip>
            <Divider type="vertical" />
            {isControlPanel && (
              <Tooltip
                title={this.intl.menuOptions.controlPanel}
                placement="bottom">
                <NavLink
                  className="container-header__left-item"
                  activeClassName="container-header-active"
                  to="/control-panel">
                  <img src={icon4} style={{ margin: 0 }} />
                </NavLink>
              </Tooltip>
            )}


            {/* <Dropdown
              overlay={this.dropdownQuestions}
              placement="bottomRight"
              className="container-header__left-item">
              <QuestionCircleFilled
                style={{
                  color: "white",
                  fontSize: "16px",
                  padding: "12px 10px",
                }}
              />
            </Dropdown> */}

            <Divider type="vertical" />
            <NotificationContainer />
            <Divider type="vertical" />
          </Fragment>
          <UserHeaderBox
            changeRole={
              isAdministrator
                ? isAmbassador()
                  ? "Embajador"
                  : isLeader()
                  ? "Líder"
                  : null
                : null
            }
          />
        </div>
      </div>
    )
  }
}

Admin.propTypes = {}

export default Admin
